// extracted by mini-css-extract-plugin
export default {"message":"MessageCard_message__Z0pJ1","container":"MessageCard_container__JNLUf"};